import { WSwiper as Swiper } from './Swiper.web';
export default Swiper;
